export default "__VITE_ASSET__DMdzgx07__"